import React from 'react'
import { getNavigationList } from './StickyNavigationList'
import { openAccordion, closeAccordion, isAccordionOpen, scrollToAccordion } from '../../helpers/openAccordion'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import formatDataTest from '../../helpers/formatDataTest'

import * as Styled from './StickyNav.styles'

const navLinkClick = (navItem, isOpen) => () => {
  const { text, name, toElement } = navItem

  if (isOpen) {
    scrollToAccordion(toElement)
  } else if (name !== 'cnet' && !isAccordionOpen(toElement)) {
    closeAccordion('#cnet-accordion')

    setTimeout(() => openAccordion(toElement), 500)
  } else {
    openAccordion(toElement)
  }

  pushEventAndTrack({
    eventInfo: {
      eventName: 'pdp_stickyBarAnchorLink',
      eventAction: 'PDP Sticky Bar Anchor Link'
    },
    attributes: {
      link: text
    }
  })
}

const createListItem = ({ currentlyInViewport, dataTest }) => (navItem, index) => {
  const { text, name } = navItem
  const isOpen = currentlyInViewport[name].isOpen
  const formattedDataTest = formatDataTest(`${dataTest} nav`, text, 'button')
  return (
    <Styled.ListItem key={index} isOpen={isOpen} data-test={`${dataTest}-list-item`}>
      <Styled.Button
        onClick={navLinkClick(navItem, isOpen)}
        onKeyPress={navLinkClick(navItem, isOpen)}
        role='link'
        tabIndex='0'
        data-test={formattedDataTest}
      >
        {text}
      </Styled.Button>
    </Styled.ListItem>
  )
}

const StickyNav = props => {
  const { currentlyInViewport, dataTest, hideNav } = props

  const originalList = getNavigationList()
  const isItemOnThePage = navItem => currentlyInViewport[navItem.name]?.isOnPage
  const isOnPageNavList = originalList.filter(isItemOnThePage)
  const listOfCss = isOnPageNavList.map(currentElement => currentElement.toElement.replace('#', ''))
  const list = isOnPageNavList.map(createListItem({ currentlyInViewport, dataTest }))

  return (
    !hideNav && (
      <Styled.Container items={listOfCss} currentClassName='active' offset={-170}>
        {list}
      </Styled.Container>
    )
  )
}

export default StickyNav
